import StoreUtil from "../store.util";

const mutations = {
  SET_ALL_EXAMINATIONS(state, payload) {
    state.examinations = StoreUtil.updateState(state.examinations, payload);
  },
};

export default mutations;
